import { Helmet } from 'react-helmet';
import pageStyles from '../styles/page-common.module.css';
import newsStyles from '../styles/page-news.module.css';

const newsItems = [
  {
    date: "May 14 2025",
    title: "Update to Our Story Release Schedule 📅",
    content: [
      "Starting now and continuing for the next few months, new stories will be released monthly instead of weekly. The new stories will land on the first Monday of each month.",
      "While stories will arrive less frequently for now, we're using this extra time to improve the quality of the stories, and refine the features of LingoLeaf.",
      "We plan to return to weekly updates in the future."
    ]
  },
  {
    date: "March 29 2025",
    title: "Study Reminder Emails 📧",
    content: [
      "We've implemented study reminder emails! The first one went out today.",
      "Every Friday, we'll send out a study reminder email to every user who has not yet completed a tree that week, provided they have opted in to reminder emails.",
      "To opt in, check the box in the Settings menu.",
    ]
  },
  {
    date: "January 30 2025",
    title: "We're Live! 🚀",
    content: [
      "After months of hard work, we're thrilled to announce that LingoLeaf is officially live!",
      "We've launched with 6 learning languages; English, Spanish, Hindi, German, French, and Japanese. As of today, each language has 12 trees available (4 per difficulty level), each with translations in English and Spanish.",
      "Sign up now and start collecting trees!"
    ]
  },
];

function News() {
  return (
    <>
      <Helmet>
        <title>News | LingoLeaf</title>
        <meta name="description" content="Stay updated with the latest announcements, additions, and improvements to LingoLeaf's language-learning platform." />
      </Helmet>
      <div className={pageStyles.styledPageLeftAligned}>
        <h1>News</h1>
        {newsItems.map((item, index) => (
          <div key={index} className={newsStyles.newsItemContainer}>
            <p className={newsStyles.newsDate}>{item.date}</p>
            <h2 className={newsStyles.newsTitle}>{item.title}</h2>
            {item.content.map((line) => {
              return <p className={newsStyles.newsLine}>{line}</p>
            })}
            
          </div>
        ))}
      </div>
    </>
  );
}

export default News;